import { useTheme } from '@mui/material';
import { Config } from 'plotly.js';
// @ts-ignore
import * as localeDictionary from 'plotly.js/lib/locales/de';
// @ts-ignore
import Plotly from 'plotly.js-cartesian-dist';
import { PlotParams } from 'react-plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';

Plotly.register(localeDictionary);
// @ts-ignore
Plotly.setPlotConfig({
  locale: 'de',
  scrollZoom: false,
  displaylogo: false,
  modeBarButtonsToRemove: [
    'autoScale2d',
    'lasso2d',
    'zoom2d',
    'zoomIn2d',
    'zoomOut2d',
    'pan2d',
    'select2d',
    'resetScale2d',
  ],
} as Partial<Config>);

const PlotlyPlot = createPlotlyComponent(Plotly);

export function Plot({ ...props }: PlotParams) {
  const theme = useTheme();

  return (
    <PlotlyPlot
      {...props}
      layout={{
        paper_bgcolor: theme.palette.tertiary.light,
        plot_bgcolor: theme.palette.tertiary.light,
        font: { family: theme.typography.fontFamily, size: 14 },
        autosize: true,
        ...props.layout,
      }}
    />
  );
}
